import axios from "axios";

const axiosInstance = axios.create({});

const BASE_URL = process.env.REACT_APP_BASE_URL;

// Refresh axios instance with token
const refreshAxiosInstance = (jwtToken) => {
  // Sanitize the token to remove any surrounding double quotes
  const sanitizedToken = jwtToken.replace(/^"|"$/g, "");
  axiosInstance.defaults.headers.common.Authorization = `Bearer ${sanitizedToken}`;
};

const localStorageJwt = localStorage.getItem("accessToken");
if (localStorageJwt) {
  refreshAxiosInstance(localStorageJwt);
}

axiosInstance.interceptors.request.use(
  async (config) => {
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

axiosInstance.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    if (
      error.response &&
      error.response.status === 401 &&
      !originalRequest._retry
    ) {
      originalRequest._retry = true;

      try {
        const response = await axios.post(
          `${BASE_URL}/backend/user/refresh-tokens`,
          {},
          {
            withCredentials: true,
          }
        );

        const newTokens = response.data.tokens;

        if (newTokens) {
          // Update tokens in local storage
          updateTokensInLocalStorage({
            accessToken: newTokens.access.token,
            refreshToken: newTokens.refresh.token,
          });
          const sanitizedToken = newTokens.access.token.replace(/^"|"$/g, "");
          originalRequest.headers.Authorization = `Bearer ${sanitizedToken}`;
          return axiosInstance(originalRequest);
        }
      } catch (refreshError) {
        console.error(
          "Refresh token expired or invalid. Logging out.",
          refreshError
        );
        logoutSuccess();
        return Promise.reject(refreshError);
      }
    }

    return Promise.reject(error);
  }
);

const logoutSuccess = () => {
  localStorage.removeItem("user");
  localStorage.removeItem("accessToken");
  window.location.href = "/";
};

const updateTokensInLocalStorage = (tokens) => {
  localStorage.setItem("accessToken", JSON.stringify(tokens.accessToken));
};

export default axiosInstance;

export { axiosInstance, refreshAxiosInstance };
